import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';
import appConstants from '@/config/constants';
import appConfig from '@/config/config';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const vuexCookie = new VuexPersistence({
  restoreState: key => {
    let localStorageData = JSON.parse(window.localStorage.getItem(key));
    if (localStorageData) {
      let stateExpirationTime = moment(localStorageData.stateSaveTime).add(
        appConfig.STATE_STORAGE_SAVE_DURATION_IN_MINUTES,
        'minutes'
      );
      if (moment(new Date()).isBefore(stateExpirationTime)) {
        return localStorageData;
      } else {
        localStorage.removeItem(key);
        return null;
      }
    } else {
      return null;
    }
  },
  saveState: (key, state) => {
    state.stateSaveTime = moment(new Date());
    window.localStorage.setItem(key, JSON.stringify(state));
  }
});

export default new Vuex.Store({
  state: {
    appRootServices: {
      dialogConfirm: () => null,
      reloadHoverableButtons: () => null
    },
    currentLevelCode: '',
    // this is used in game ui to decide if the intro for levels should be shown.
    // it will always be shown on white belt, but if the player entered a beltCode and started playing from any other belt,
    // it will also play the intro thanks to this condition.
    firstTimePlaying: true,
    unlockedLevels: {
      white: 1, // fist level is always enabled.
      yellow: 1,
      orange: 1,
      green: 1,
      blue: 1,
      black: 0
    },
    unlockedBelts: {
      white: true, // always unlocked
      yellow: false,
      orange: false,
      green: false,
      blue: false,
      black: false
    }
  },
  getters: {
    getUnlockedBelts: state => state.unlockedBelts,
    getUnlockedLevels: state => state.unlockedLevels,
    getAppRootServices: state => state.appRootServices,
    getFirstTimePlaying: state => state.firstTimePlaying
  },
  mutations: {
    setFirstTimePlaying(state, payload /* Boolean */) {
      state.firstTimePlaying = payload;
    },
    setReloadHoverableButtons(state, reloadHoverableButtons) {
      state.appRootServices.reloadHoverableButtons = reloadHoverableButtons;
    },
    setDialogConfirm(state, dialogConfirm) {
      state.appRootServices.dialogConfirm = dialogConfirm;
    },
    setUnlockedLevels(state, { beltColor, levelsToUnlock }) {
      state.unlockedLevels[beltColor] = levelsToUnlock;
    },
    resetUnlockedBelts(state) {
      state.unlockedBelts = {
        white: true,
        yellow: false,
        orange: false,
        green: false,
        blue: false,
        black: false
      };
      state.unlockedLevels = {
        white: 1,
        yellow: 1,
        orange: 1,
        green: 1,
        blue: 1,
        black: 0
      };
    }
  },
  actions: {
    setBeltCodeLogic(context, beltCode) {
      // eslint-disable-next-line
      const beltDataObj = appConstants.beltsCodes[beltCode /* for example: yellow */];
      // beltDataObj: { beltsToUnlockArr, beltColor }
      // unlocks the belt the code is refereeing
      context.state.unlockedBelts[beltDataObj.beltColor] = true;
      // unlock other belts. for example, when unlocking green beltCode,
      //its also required to unlock orange, yellow and white belts.
      for (const beltColor of appConstants.beltsArr) {
        // beltsArr is [String] of the all the belts (except black)
        if (beltDataObj.beltsToUnlockArr.includes(beltColor)) {
          // if belts to unlock Arr, which is determined by the code given by user, includes the current belt, unlock it:
          // unlocks the belt
          context.state.unlockedBelts[beltColor] = true;
          // unlocks all its levels
          context.commit('setUnlockedLevels', { beltColor, levelsToUnlock: 6 });
        }
      }
    }
  },
  plugins: [vuexCookie.plugin]
});
